import * as React from 'react';

/**
 * Контейнер формы добавления вопроса
 */
export const AddQuestionFormContainer = () => {
  return <div>Форма добавления вопроса</div>;
};
